const careteGetSizeByWidth = ({ width }: { width: number }) => {
  return (pixel: number, unit = 'vw') => {
    return `${(pixel / width) * 100}${unit}`
  }
}

export const getSizeBy375 = careteGetSizeByWidth({ width: 375 })
